import React, { PropsWithChildren } from 'react';
import { NetworkErrorStatus, TunzNetworkError } from '@tunz/http';
import { Loading } from '@tunz/ifs-react-lib';

import App from './App';
import { LoginContext, LoginProvider, useUserInfo } from './Components/Login';
import MicroFrontendPropsContext from './Services/ModuleService/MicroFrontendPropsContext';
import useMFEProps from './Components/Portal/useMFEProps';

import { WebBrandProvider } from './Components/WebBrand';
import OTPInput from './Components/OTPInput';
import HttpClientHelper from './Utils/HttpClientHelper';
import BOLink from './Components/BOLink';
import RouterLinkFormatter, {
	WalletLink,
	WalletLinkRenderer,
	HistoryWalletLink,
	HistoryTrxLink,
	SearchTrxLink,
	LinkProps,
	RouterLinkFormatterV2,
} from './Components/RouterLinkDisplayers';
import SUPPORT_URL from './Components/Login/Constants';

type Props = PropsWithChildren;
const MfePortal: React.FC<Props> = ({ children }: Props) => (
	<WebBrandProvider>
		<LoginProvider supportUrl={SUPPORT_URL}>
			<App>{children}</App>
		</LoginProvider>
	</WebBrandProvider>
);

export default MfePortal;
export {
	MicroFrontendPropsContext,
	LoginContext,
	useUserInfo,
	useMFEProps,
	HttpClientHelper,
	OTPInput,
	BOLink,
	RouterLinkFormatter,
	WalletLink,
	WalletLinkRenderer,
	HistoryWalletLink,
	HistoryTrxLink,
	SearchTrxLink,
	RouterLinkFormatterV2,
	Loading,
	TunzNetworkError,
	NetworkErrorStatus,
};

export type { LinkProps };

export {
	AcquirerFormatter,
	BranchFormatter,
	CurrencyRenderer,
	EndpointFormatter,
	GatewayFormatter,
	PaymentMethodFormatter,
	ProductFormatter,
	ReferentialSelector,
	ServiceFormatter,
	useReferential,
	getAcquirers,
	getBranches,
	getCurrencies,
	getEndpoints,
	getGateways,
	getPaymentMethods,
	getProducts,
	getServices,
} from '@tunz/referentials';
